// Registre CENTRAL des langues (language packs). Source unique pour : sélecteur, i18next,
// formats Intl, wordlist du Générateur et tests de complétude. Ajouter une langue = ajouter une
// entrée ici + son dossier i18n/<code>/ + sa wordlist (voir docs/ADDING_LANGUAGE.md).
// Aucun composant ne doit coder en dur la liste des langues.
export const SUPPORTED_LOCALES = {
  fr: { code: "fr", nativeLabel: "Français", htmlLang: "fr", intlLocale: "fr-FR", enabled: true, wordlistLocale: "fr" },
  en: { code: "en", nativeLabel: "English", htmlLang: "en", intlLocale: "en-US", enabled: true, wordlistLocale: "en" },
};

// Fallback technique (une langue enabled doit être complète : vérifié par le test de parité).
export const DEFAULT_LOCALE = "fr";

// Namespaces obligatoires de chaque language pack.
export const NAMESPACES = ["common", "auth", "public", "generator", "sms", "directory", "share", "secureRequest", "workspace", "tester", "account", "billing", "history", "administration", "help", "files"];

export const ENABLED_LOCALES = Object.values(SUPPORTED_LOCALES).filter((l) => l.enabled);
export const ENABLED_CODES = ENABLED_LOCALES.map((l) => l.code);

export const normalizeLocale = (v) => {
  const base = String(v || "").toLowerCase().split("-")[0];
  return ENABLED_CODES.includes(base) ? base : DEFAULT_LOCALE;
};

export const getLocaleConfig = (v) => SUPPORTED_LOCALES[normalizeLocale(v)];

// Locale Intl (dates, nombres) dérivée de la langue d'interface. Ne détermine JAMAIS prix/devise/région.
export const intlLocaleFor = (v) => getLocaleConfig(v).intlLocale;
